import queryString from '@utils/query-string';
import semver from 'semver';

export const gte = target => {
  const queryObject = queryString.parseUrl(window.location.search);
  const { query } = queryObject;
  const current = query['babytree-app-version'] || '9.20.0';
  const a = semver.parse(current);
  const b = semver.parse(target);
  return a.major >= b.major && a.minor >= b.minor && a.patch >= b.patch;
};
